import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import { useState } from "react"
import toast from "react-hot-toast"
import { FaImages } from "react-icons/fa6"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const importFilePrestasi = async (newData: FormData) => {
  const response = await api.post(
    "/import/penerimaan/data-prestasi/file",
    newData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
  return response.data
}

export default function FormImportFilePrestasi({
  closeModal,
}: {
  closeModal: () => void
}) {
  const [files, setFiles] = useState<File[]>([])

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files
    if (selectedFiles) setFiles(Array.from(selectedFiles))
  }

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: importFilePrestasi,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listDataPrestasi"] })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData()

    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file)
    })

    mutate(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader title="Import File Prestasi" icon={<FaImages />} />

      <div>
        <Label>File Prestasi</Label>
        <Input type="file" multiple onChange={handleFileChange} />
      </div>
      <div className="mt-3 flex gap-3">
        <Button type="button" onClick={closeModal} disabled={isPending}>
          Batal
        </Button>
        <Button
          variant={"outline"}
          className="flex items-center gap-3"
          disabled={isPending}
        >
          {isPending ? (
            <>
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            "Import"
          )}
        </Button>
      </div>
    </form>
  )
}
